<template>
  <div class="vp-flex vp-justify-center">
    <VpVueForm
      :fields="fields"
      id="+"
      class="vp-p-6"
      :save="save"
      #default="{ state, setValue }"
      width="400px"
      feature="CARDS"
    >
      <VpPageHeader title="Get started with Vepaar Cards!" />

      <VpField
        rules="required"
        label="Card Name"
        name="Card Name"
        note="Use your name if this is your personal card. Use your company name if this is for your company. You can change it later."
      >
        <VpInput>
          <VpTextBox
            v-model="state.name"
            @input="
              setValue('subdomain', $options.kebabCase(state.name, 'kebabCase'))
            "
          />
        </VpInput>
      </VpField>

      <VpField
        :rules="{
          required: true,
          min: 5,
          subdomain: true,
        }"
        label="Card Link"
        name="Card Link"
        note="People can see your card by visiting this link. You can change it later."
      >
        <VpInput after=".vepaar.cards">
          <VpTextBox v-model="state.subdomain" />
        </VpInput>
      </VpField>

      <VpField
        v-if="state.subdomain"
        label="This is how your link will look like:"
      >
        <VyButton
          class="button--primary"
          :label="`https://${state.subdomain}.vepaar.cards`"
        />
      </VpField>
    </VpVueForm>
  </div>
</template>

<script>
import upsert from "./upsert.gql";
import { kebabCase } from "lodash-es";

export default {
  kebabCase,
  data() {
    return {
      fields: ["name", "subdomain"],
    };
  },

  methods: {
    async save(id, data) {
      return this.$mutate(upsert, {
        input: {
          ...data,
        },
      }).then(({ data }) => {
        this.$router.push("/");
        return data;
      });
    },
  },
};
</script>
